import { principles, stats, testimonials } from "@/mocks/site";

export default function TrustSection() {
  return (
    <section aria-label="内容原则与读者口碑" className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-5">
        {stats.map((item) => (
          <div key={item.label} className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-6">
            <p className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">{item.value}</p>
            <p className="mt-2 text-xs text-foreground-600 md:text-sm">{item.label}</p>
          </div>
        ))}
      </div>

      <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-5">
          <p className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-secondary-600">
            <span className="h-1 w-6 bg-secondary-500"></span>
            OUR RULES
          </p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            我们只写能站得住的内容
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            娱乐爆料最容易滑向捕风捉影。我们给自己定了四条硬规则，用来判断一条线索值不值得写。
          </p>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {principles.map((item) => (
              <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <h3 className="mt-3 font-heading text-sm font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">{item.text}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-7">
            <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <span className="flex h-5 w-5 items-center justify-center text-accent-600">
                <i className="ri-chat-quote-line"></i>
              </span>
              读者怎么说
            </h3>
            <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {testimonials.map((item) => (
                <figure key={item.name} className="flex flex-col rounded-lg bg-background-50 p-4">
                  <blockquote className="flex-1 text-sm leading-relaxed text-foreground-700">
                    「{item.text}」
                  </blockquote>
                  <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-3">
                    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 font-heading text-xs font-bold text-primary-700">
                      {item.name.slice(0, 1)}
                    </span>
                    <span className="flex flex-col">
                      <span className="text-xs font-medium text-foreground-900">{item.name}</span>
                      <span className="text-[11px] text-foreground-500">{item.role}</span>
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}